import accounting from 'accounting';

const formatMoney = (amount, options = {}) => {
  const amountToFormat = options.wholeDollars ? Math.ceil(amount) : amount;
  const precision = options.wholeDollars ? 0 : 2;
  return accounting.formatMoney(amountToFormat, options?.symbol, precision);
};

export default formatMoney;
